import React from 'react';
const specs = [{
  label: 'Format',
  value: 'PDF — Instant Digital Download'
}, {
  label: 'Length',
  value: '16 Chapters + Exclusive Epilogue'
}, {
  label: 'Edition',
  value: 'First Digital Edition, 2026'
}, {
  label: 'Device',
  value: 'Phone, Tablet, Desktop, E-Reader'
}, {
  label: 'Access',
  value: 'Immediate — delivered to your inbox'
}, {
  label: 'Layout',
  value: 'High-contrast editorial, optimized for night reading'
}];
export function FormatSpecsSection() {
  return <section className="w-full bg-editorial-bg py-section-mobile md:py-section-desktop px-6 md:px-8 border-t border-editorial-divider bg-gradient-to-b from-editorial-bg to-editorial-bgAlt" data-id="element-64">
      <div className="max-w-3xl mx-auto" data-id="element-65">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-editorial-text text-center mb-12" data-id="element-66">
          The Format
        </h2>

        <div className="w-full bg-editorial-card p-8 md:p-12 rounded-xl border border-editorial-divider/50 shadow-xl" data-id="element-67">
          <table className="w-full text-left border-collapse" data-id="element-68">
            <tbody className="font-sans text-base md:text-lg text-editorial-text" data-id="element-69">
              {specs.map((spec, idx) => <tr key={idx} className="border-b border-editorial-divider last:border-0" data-id="element-70">
                  <td className="py-5 px-2 align-top text-editorial-textMuted w-1/3 md:w-1/4 font-medium" data-id="element-71">
                    {spec.label}
                  </td>
                  <td className="py-5 px-2 align-top" data-id="element-72">{spec.value}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </section>;
}